import { render, staticRenderFns } from "./ScreenSalleSuper.vue?vue&type=template&id=71460138&scoped=true"
import script from "./ScreenSalleSuper.vue?vue&type=script&lang=js"
export * from "./ScreenSalleSuper.vue?vue&type=script&lang=js"
import style0 from "./ScreenSalleSuper.vue?vue&type=style&index=0&id=71460138&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71460138",
  null
  
)

export default component.exports